<template>
  <div class="articles-selector-option" :class="classList">
    <button class="select-button" @click="handleClickSelectButton">
      <img class="thumb" :src="imageOrCoverUrl" />
      <div class="meta">
        <h4 class="name">{{ title }}</h4>
        <p>{{ category }}</p>
      </div>
    </button>
    <div class="action" v-if="canRemove">
      <sc-button variant="clean" :icon="true" @click="handleClickRemoveButton">
        <img src="/static/icons/close-red.svg" />
      </sc-button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ScButton from "@/lib/components/ScButton";

export default {
  components: {
    ScButton
  },
  props: [
    "id",
    "title",
    "content",
    "category",
    "imageUrl",
    "cover",
    "canSelect",
    "canRemove",
  ],
  data() {
    const imageOrCoverUrl = '';
    return {
      imageOrCoverUrl
    }
  },
  computed: {
    classList() {
      return { selectable: this.canSelect };
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      if (this.cover) {
        this.imageOrCoverUrl = await axios
          .get(`${process.env.HOST}/api/downloads/image`, {
            params: {
              imageKey: this.cover
            }
          })
          .then(res2 => {
            return res2.data.url;
          })
          .catch(e2 => {
            $state.complete();
            throw e2;
          });
      } else {
        this.imageOrCoverUrl = this.imageUrl;
      }
    },
    handleClickSelectButton() {
      if (this.canSelect === true) {
        this.$emit("select");
      } else {
        // const serviceId = this.id;
        // const routeByServiceId = { name: "ServiceDetailPage", params: { id: serviceId } };
        // const routeDataByServiceId = this.$router.resolve(routeByServiceId);

        // window.open(routeDataByServiceId.href, '_blank');
      }
    },
    handleClickRemoveButton() {
      this.$emit("remove");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 48px;
$thumbHeight : 48px;
$thumbWidth : 64px;
$padding: 10px ($space / 2);

.articles-selector-option {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: $padding;

  font-family: "Sukhumvit Tadmai";

  > .select-button {
    cursor: grabbing;
    user-select: text;
  }

  &.selectable {
    padding: 0;

    > .select-button {
      padding: $padding;
      cursor: grabbing;
    }

    &:hover {
      background: #efefef;
    }
  }

  > .action {
    align-self: center;
  }
}

.select-button {
  display: flex;
  flex-flow: row nowrap;

  border: 0;
  padding: 0;
  outline: 0;
  min-width: 0;

  background: transparent;

  > .icon {
    margin-top: 5px;

    flex: 0 0 $logoSize;
  }

  > .meta {
    padding-left: 20px;
    display: block;

    flex-grow: 1;

    &:not(:last-child) {
      padding-right: 20px;
    }
  }
}

.thumb {
  display: block;

  border-radius: 8px;
  width: $thumbWidth;
  height: $thumbHeight;
}

.meta {
  min-width: 0;

  > .desc {
    overflow: hidden;
    height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.meta .name {
  margin: 0;
  font-size: 0.9rem;
}

.meta p {
  font-size: 0.8rem;
  color: #777;
}

.meta .name,
.meta p {
  text-align: left;
  line-height: 1.6;
}

.title {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  > .provider {
    padding-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/lib/components/ArticlesSelector/ArticlesSelectorOption.vue